var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"course__list py-4"},[_c('div',{staticClass:"container"},[_c('v-client-table',{attrs:{"name":"purchaseTable","data":_vm.sales_data,"columns":_vm.columns,"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }